/**
 * A plain, deep copy of a JSON-shaped prop. Props arrive as Vue reactive
 * proxies, and the v3 loader posts its options into an iframe with
 * postMessage, which cannot clone a proxy - the editor then never boots
 * (`DataCloneError: #<Object> could not be cloned`).
 */
export const plainCopy = <T>(value: T): T => JSON.parse(JSON.stringify(value));
